import Route from 'rise-ui/utils/routing/route.js';

import { service } from '@ember/service';

export default class HelpTopicRoute extends Route {
  @service router;

  beforeModel(transition) {
    const { help_topic_id } = transition.to.params;
    this.router.replaceWith('help.search', { queryParams: { topic: help_topic_id } });
  }
}
